import React, { useContext, useEffect, useState } from "react";
import { Box, TextField, Button } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useDispatch, useSelector } from "react-redux";
import { useMessage } from "../../../base/MessageProvider";
import { useNavigate } from "react-router-dom";
import Timer from "../../../components/Timer";
import { otpLogin, verifyLoginOtp } from "../../actions/auth";
import clsx from "clsx";
import { Bars } from "react-loader-spinner";

/**
 * @author Sarthak Sharma.
 * @since 08-12-2023.
 * @description Otp Login page.
 */

const loginStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  width: "90%",
  bgcolor: "white",
  paddingX: 6,
  paddingY: 3,
  borderRadius: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const OtpLogin = (): React.ReactElement => {
  const [otp, setOtp] = React.useState("");
  const [resendState, setResendState] = useState(false);
  const [resetTimer, setResetTimer] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const loading = useSelector((state) => state.authReducer?.loading);

  const requiredOtp = useSelector((state) => state.authReducer?.otpLoginData);
  const userId = useSelector((state) => state.authReducer?.userId);
  const mobileNo = useSelector((state) => state.authReducer?.mobileNo);

  const toast = useMessage();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(requiredOtp);
    setErrorMessage("");
    if (requiredOtp) {
      toast.showInfo(`OTP ${requiredOtp}`, { timeout: 5000 });
    } else {
      navigate("/admin/login", { replace: true });
    }
  }, []);

  const handleChange = (newValue) => {
    setOtp(newValue);
  };

  const validateChar = (value, index) => {
    const isNumber = typeof value === "number";
    const isString = typeof value === "string";
    return (isNumber || (isString && value !== "")) && !isNaN(Number(value));
  };

  const handleComplete = (value) => {
    setErrorMessage("");
    dispatch(
      verifyLoginOtp(
        { userId, otp: value },
        () => {
          navigate("/admin", { replace: true });
        },
        (error) => {
          setErrorMessage(error?.message);
        }
      )
    );
  };

  const handleTimeUp = () => {
    // handle time up here
    setResendState(true);
  };

  const handleResendOtp = async () => {
    dispatch(
      otpLogin(
        { mobileNo },
        (loginOtp) => {
          // toast.showInfo(loginOtp, {
          //   timeout: 5000,
          // });
          setResendState(false);
          setResetTimer((prev) => !prev);
        },
        (error) => {
          setErrorMessage(error?.message ?? "Something went wrong!!");
        }
      )
    );
  };

  return (
    <Box className="h-screen w-screen login-form">
      <Box sx={loginStyle}>
        {/* <h1 className="font-['CG-SemiBold'] text-[38px] leading-9 tracking-[0.14em]">STARNEX</h1> */}
        <img
          src={require("../../../assets/images/white-bg-logo.png")}
          className="h-[40px]"
        />
        <div className="w-full my-5">
          <h2 className="w-full text-left font-['CG-Medium'] text-[24px]">
            Otp Verification
          </h2>
          <div className="flex flex-col gap-3">
            <span className="text-[12px] text-[#6D7175] font-['CG-Regular']">
              Enter Received Otp
            </span>
            <MuiOtpInput
              length={5}
              value={otp}
              onChange={handleChange}
              validateChar={validateChar}
              TextFieldsProps={{ disabled: loading }}
              onComplete={handleComplete}
            />
          </div>
          {errorMessage && (
            <div className="flex my-2">
              <div className="text-[14px] text-red-600">{errorMessage}</div>
            </div>
          )}
          <div className="flex gap-2 justify-end items-center my-3">
            <Timer
              key={`key-${resetTimer}`}
              duration={300}
              timeUpCallback={handleTimeUp}
            />
            <Button
              disabled={!resendState}
              onClick={handleResendOtp}
              className={clsx(
                "text-[15px] font-['CG-Medium'] cursor-pointer hover:underline",
                {
                  "text-[#26805F]": resendState,
                  "text-[#26805fa1]": !resendState,
                }
              )}
            >
              Resend OTP
            </Button>
          </div>
          <div className="w-full flex gap-3 justify-center">
            <Bars
              height="20"
              width={"20"}
              animationDuration="0.75"
              color="#26805F"
              ariaLabel="bars-loading"
              visible={loading}
            />
          </div>
          {/* <button className="bg-[#26805F] rounded-[4px] active:bg-gray-500 w-full h-[43px] my-5 text-[14px] text-[#F2F2F2] font-['Poppins-Medium']">Log In</button> */}
        </div>
      </Box>
    </Box>
  );
};

export default OtpLogin;
